import React, { useRef } from "react";
import { motion } from "framer-motion";

const equipmentData = [
  {
    title: "License Plate Recognition",
    description: "Automatically identify and process vehicles using advanced LPR technology — no manual input required.",
    image: "/images/carwash-sec/lpr-new.webp",
  },
  {
    title: "RFID",
    description: "RFID-ready system for seamless fleet management and automated access control.",
    image: "/images/carwash-sec/i3.jpeg",
  },
  {
    title: "Age Recognition",
    description: "AI-powered age recognition for tailored advertising and targeted promotions.",
    image: "/images/carwash-sec/i1.jpeg",
  },
  {
    title: "Support",
    description: "Dedicated support available to keep your kiosk running at peak performance.",
    image: "/images/carwash-sec/i2.jpeg",
  },
];

export const CarwashEquipment = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -340 : 340,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="py-20 px-6 lg:px-8 bg-[#f5f6f8]">
      <div className="max-w-screen-xl mx-auto">

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <p className="text-xs font-semibold uppercase tracking-widest text-[#1a1f6c] mb-2">Ecosystem</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#111827] leading-tight">
            Additional Equipment
          </h2>
          <p className="text-sm sm:text-base text-[#6b7280] mt-3 max-w-xl leading-relaxed">
            Expand your kiosk capabilities with purpose-built hardware modules designed for efficiency at your fingertips.
          </p>
        </motion.div>

        <div
          ref={scrollRef}
          className="flex gap-6 pb-2 snap-x snap-mandatory scroll-smooth hide-scrollbar"
          style={{ overflowX: "auto", overflowY: "clip" }}
        >
          {equipmentData.map((item, index) => (
            <motion.div
              key={item.title}
              className="snap-start flex-shrink-0 w-[280px] sm:w-[300px] bg-white rounded-2xl overflow-hidden shadow-md"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
            >
              <div className="h-[200px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="text-[#111827] font-bold text-lg mb-2">{item.title}</h3>
                <p className="text-[#6b7280] text-sm leading-relaxed">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="flex justify-end gap-3 mt-8">
          <button
            onClick={() => scroll("left")}
            className="w-10 h-10 rounded-lg bg-[#1a1f6c] text-white flex items-center justify-center hover:bg-[#2832c2] transition-colors duration-300"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button
            onClick={() => scroll("right")}
            className="w-10 h-10 rounded-lg bg-[#1a1f6c] text-white flex items-center justify-center hover:bg-[#2832c2] transition-colors duration-300"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};